import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface Props {
  name: string | null;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteGeofenceDialog({ name, pending, onConfirm, onCancel }: Props) {
  return (
    <Dialog open={name != null} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Supprimer la zone</DialogTitle>
          <DialogDescription>
            « {name} » sera supprimée définitivement, avec ses règles d&apos;alerte. Cette action est irréversible.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Annuler</Button>
          <Button variant="destructive" disabled={pending} onClick={onConfirm}>{pending ? 'Suppression…' : 'Supprimer'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
